import React, { useContext, useState } from 'react';
import { Text, Flex, Box } from '@chakra-ui/layout';
import { Button, Icon } from '@chakra-ui/react';
import { Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay } from '@chakra-ui/modal';
import { MdOutlineWarning } from 'react-icons/md';
import { SharedExperiencesContext } from '../lib/sharedExperiencesProvider';
import { useSharedExperiencesApi } from '../lib/useSharedExperiencesApi';
import { useNavigate } from 'react-router-dom';

export default function DeleteSharedExperienceModal(props) {
  const { disclosure } = props;
  const { sharedExperience } = useContext(SharedExperiencesContext);
  const [isDeleting, setIsDeleting] = useState(false);
  const sharedExperiencesApi = useSharedExperiencesApi();
  const navigate = useNavigate();

  const deleteSharedExperience = async () => {
    try {
      setIsDeleting(true);
      await sharedExperiencesApi.deleteSharedExperience(sharedExperience.id);
      setIsDeleting(false);
      navigate(-1);
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <>
      {disclosure && (
        <Modal isOpen={disclosure.isOpen} onClose={disclosure.onClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Delete Shared Experience {sharedExperience && sharedExperience.name}</ModalHeader>
            <ModalBody>
              <Box p={3}>
                {(sharedExperience && sharedExperience.name) && (
                  <>
                    <Flex
                      border="1px"
                      borderColor="divider.grey"
                      borderRadius="2px"
                      backgroundColor="white"
                      alignItems={'center'}
                      p={3}
                      mb={2}
                    >
                      <Icon
                        as={MdOutlineWarning}
                        color={'text.medium.red'}
                        boxSize={'18px'}
                        mr={3}
                      />
                      <Text textStyle="body" color={'text.medium.red'}>
                        Are you sure to delete shared experience {sharedExperience.name}?
                      </Text>
                    </Flex>
                    <Flex
                      border="1px"
                      borderColor="divider.grey"
                      borderRadius="2px"
                      backgroundColor="white"
                      alignItems={'center'}
                      p={3}
                    >
                      <Text textStyle="body" color={'text.medium.red'}>
                        It will be removed from all associated personas and products.
                      </Text>
                    </Flex>
                  </>
                )}
              </Box>
            </ModalBody>
            <ModalFooter>
              <Button
                variant='redOutline'
                onClick={disclosure.onClose}
              >
                Close
              </Button>
              <Button
                variant="redFill"
                ml={2}
                isLoading={isDeleting}
                onClick={deleteSharedExperience}
              >
                Delete
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      )}
    </>
  );
} 